import React from 'react'
import {DateFormat} from '../../Utils'
import * as routes from '../../constants/routes'

class FuelEntry extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      date: DateFormat(new Date(), "yyyy-mm-dd"),
      odometer: "",
      unit_price: "",
      units: "",
      octane: ""
    };

    this.handleChange = this.handleChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.car = props.match.params.car;
  }

  handleChange(event) {
    const target = event.target;
    const name = target.name;
    const value = target.type === 'checkbox' ? target.checked : target.value;

    this.setState({
      [name]: value
    });
  }

  handleSubmit(e) {
  	e.preventDefault();
    const result = {...this.state,vehicle:this.car };
    this.props.onChange(result)
  	this.props.history.push(routes.HOME)
  }

  render() {
    return (
    	<div>
        <h1>{this.car}</h1>
	      <form onSubmit={this.handleSubmit}>
          <input type="date" name="date" value={this.state.date} onChange={this.handleChange} placeholder="Date" />
          <input type="number" name="odometer" value={this.state.odometer} onChange={this.handleChange} placeholder="Mileage" />
          <input type="number" name="unit_price" value={this.state.unit_price} onChange={this.handleChange} placeholder="Price" />
          <input type="number" name="octane" value={this.state.octane} onChange={this.handleChange} placeholder="Octane: 87, 89, 91" pattern="\d*" />
          <input type="number" name="units" value={this.state.units} onChange={this.handleChange} placeholder="Gallons" /> 
          <div className="button-footer">
            <button>Add Fill-Up</button>
          </div>
	      </form>
      </div>
    );
  }
}
 
export default FuelEntry


// WEBPACK FOOTER //
// ./src/components/FuelEntry/index.js